import i18n from 'core/utils/i18n';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { initialize } from 'core/keycloak/keycloak';

i18n.changeLanguage('de');

initialize(process.env.REACT_APP_MODULE || 'senator').then(() => {
  const App: React.ComponentType = require(`./${process.env.REACT_APP_MODULE}/App`).default;
  ReactDOM.render(<App />, document.getElementById('root'));
}).catch(err => {
  console.error('Failed to initialize Keycloak', err);
  ReactDOM.render(
    <div>Initialization failed. Check console.</div>,
    document.getElementById('root')
  );
});

serviceWorker.unregister();